const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

/**
 * @typedef {Object} RequestTypes
 * @property {string} REQUEST - The request type.
 * @property {string} SUCCESS - The success type.
 * @property {string} FAILURE - The failure type.
 */

/**
 * Creates request types based on the provided base.
 *
 * @param {string} base - The base string for creating request types.
 * @returns {RequestTypes} The request types object.
 */
function createRequestTypes(base) {
    return [REQUEST, SUCCESS, FAILURE].reduce((acc, type) => {
        acc[type] = `${base}_${type}`;
        return acc;
    }, /** @type {RequestTypes} */({}));
}

/**
 * User
 * */
export const GET_USER = createRequestTypes('GET_USER');
export const AUTH_USER = createRequestTypes('AUTH_USER');
export const LOGOUT_USER = createRequestTypes('LOGOUT_USER');
export const GET_USER_LIST = createRequestTypes('GET_USER_LIST');
export const BAN_USER_BY_ID = createRequestTypes('BAN_USER_BY_ID');
export const UNBAN_USER_BY_ID = createRequestTypes('UNBAN_USER_BY_ID');
export const GET_USER_LIMITATIONS_LIST = createRequestTypes('GET_USER_LIMITATIONS_LIST');
export const SET_USER_TO_WHITE_LIST = createRequestTypes('SET_USER_TO_WHITE_LIST');
export const SET_USER_TO_BLACK_LIST = createRequestTypes('SET_USER_TO_BLACK_LIST');
export const TOGGLE_WHITE_LIST = createRequestTypes('TOGGLE_WHITE_LIST');
export const ADD_USERS_FROM_AUTOCOMPLETE = 'ADD_USERS_FROM_AUTOCOMPLETE';

/**
 * Cargo types
 * */
export const GET_CARGO_TYPES = createRequestTypes('GET_CARGO_TYPES');

/**
 * Cargo assigners
 * */
export const GET_CARGO_ASSIGNERS = createRequestTypes('GET_CARGO_ASSIGNERS');
export const GET_CARGO_ASSIGNERS_POST = createRequestTypes('GET_CARGO_ASSIGNERS_POST');
export const UPDATE_CARGO_ASSIGNER = createRequestTypes('UPDATE_CARGO_ASSIGNER');
export const DELETE_CARGO_ASSIGNER = createRequestTypes('DELETE_CARGO_ASSIGNER');
export const SAVE_STATUS_CARGO_ASSIGNER = 'SAVE_STATUS_CARGO_ASSIGNER';
export const SEARCH_CARGO_ASSIGNERS = 'SEARCH_CARGO_ASSIGNERS';
export const CLEAR_STATUS_CARGO_ASSIGNER = 'CLEAR_STATUS_CARGO_ASSIGNER';

/**
 * Cargo gazetters
 */
export const GET_CARGO_GAZETTERS = createRequestTypes('GET_CARGO_GAZETTERS');
export const DELETE_CARGO_GAZETTER = createRequestTypes('DELETE_CARGO_GAZETTER');

/**
 * Cargo real names
 * */
export const GET_CARGO_REAL_NAMES = createRequestTypes('GET_CARGO_REAL_NAMES');
export const GET_CARGO_REAL_NAMES_PAGINATED = createRequestTypes('GET_CARGO_REAL_NAMES_PAGINATED');
export const UPDATE_CARGO_REAL_NAME = createRequestTypes('UPDATE_CARGO_REAL_NAME');
export const DELETE_CARGO_REAL_NAME = createRequestTypes('DELETE_CARGO_REAL_NAME');
export const GET_CARGO_TAGS_CATEGORIES = createRequestTypes('GET_CARGO_TAGS_CATEGORIES');
export const SAVE_STATUS_CARGO_REAL_NAME = 'SAVE_STATUS_CARGO_REAL_NAME';
export const CLEAR_STATUS_CARGO_REAL_NAME = 'CLEAR_STATUS_CARGO_REAL_NAME';
export const SEARCH_CARGO_REAL_NAMES = 'SEARCH_CARGO_REAL_NAMES';
export const UPDATE_TAGS_DATA_IN_ROW = 'UPDATE_TAGS_DATA_IN_ROW';

/**
 * Cargoes common
 */
export const GET_CARGOES_BY_TYPE_NAME = createRequestTypes('GET_CARGOES_BY_TYPE_NAME');

/**
 * Cargo duplicates
 * */
export const GET_CARGO_DUPLICATES = createRequestTypes('GET_CARGO_DUPLICATES');
export const DELETE_CARGO_DUPLICATE = createRequestTypes('DELETE_CARGO_DUPLICATE');
export const SEARCH_CARGO_DUPLICATES = 'SEARCH_CARGO_DUPLICATES';
export const CLEAR_DUPLICATES = 'CLEAR_DUPLICATES';

/**
 * Cargo loading and discharging
 * */
export const GET_LOADING_AND_DISCHARGING = createRequestTypes('GET_LOADING_AND_DISCHARGING');
export const DELETE_LOADING_AND_DISCHARGING = createRequestTypes('DELETE_LOADING_AND_DISCHARGING');
export const UPDATE_LOADING_AND_DISCHARGING = createRequestTypes('UPDATE_LOADING_AND_DISCHARGING');
export const SEARCH_LOADING_AND_DISCHARGING = 'SEARCH_LOADING_AND_DISCHARGING';
export const SAVE_STATUS_LOADING_AND_DISCHARGING =
    'SAVE_STATUS_LOADING_AND_DISCHARGING';
export const CLEAR_STATUS_LOADING_AND_DISCHARGING =
    'CLEAR_STATUS_LOADING_AND_DISCHARGING';

/**
 * Ports
 * */
export const GET_ALL_PORTS = createRequestTypes('GET_ALL_PORTS');
export const GET_PORTS = createRequestTypes('GET_PORTS');
export const GET_PORT = createRequestTypes('GET_PORT');
export const UPDATE_PORT_SUGGESTIONS = 'UPDATE_PORT_SUGGESTIONS';
export const UPDATE_PORT = createRequestTypes('UPDATE_PORT');
export const UPDATE_PORT_ALT = createRequestTypes('UPDATE_PORT_ALT');
export const ADD_NEW_PORT = createRequestTypes('ADD_NEW_PORT');
export const SEARCH_PORT = 'SEARCH_PORT';
export const SAVE_PORT = 'SAVE_PORT';
export const CLEAR_PORT = 'CLEAR_PORT';
export const CHANGE_PORT = 'CHANGE_PORT';

/**
 * Areas
 * */
export const GET_AREAS = createRequestTypes('GET_AREAS');
export const GET_AREA = createRequestTypes('GET_AREA');
export const UPDATE_AREA_SUGGESTIONS = 'UPDATE_AREA_SUGGESTIONS';
export const UPDATE_AREA_ALT = createRequestTypes('UPDATE_AREA_ALT');
export const UPDATE_AREA = createRequestTypes('UPDATE_AREA');
export const SEARCH_AREA = 'SEARCH_AREA';
export const SAVE_AREA = 'SAVE_AREA';
export const CLEAR_AREA_STATUS = 'CLEAR_AREA_STATUS';
export const CREATE_AREA = createRequestTypes('CREATE_AREA');
export const DELETE_AREA = createRequestTypes('DELETE_AREA');
export const REMOVE_AREA_CHILD = createRequestTypes('REMOVE_AREA_CHILD');

/**
 * Cargo entities
 * */
export const GET_TERM_ENTITIES = createRequestTypes('GET_TERM_ENTITIES');

/**
 * Letters
 * */
export const GET_LETTERS = 'GET_LETTERS';
export const GET_LETTER = createRequestTypes('GET_LETTER');
export const UPDATE_LETTER = createRequestTypes('UPDATE_LETTER');
export const REMOVE_LETTER = 'REMOVE_LETTER';

/**
 * Annotations
 * */
export const POST_ANNOTATIONS = createRequestTypes('POST_ANNOTATIONS');
export const REMOVE_ANNOTATIONS = 'REMOVE_ANNOTATIONS';

/**
 * preference
 * */
export const CREATE_FILTER_ANNOTATIONS_PREFERENCE = createRequestTypes('CREATE_FILTER_ANNOTATIONS_PREFERENCE');

/**
 * preference
 * */
export const GET_PREFERENCES = createRequestTypes('GET_PREFERENCES');
export const GET_PREFERENCE = createRequestTypes('GET_PREFERENCE');
export const DELETE_PREFERENCE = createRequestTypes('DELETE_PREFERENCE');
export const UPDATE_PREFERENCE = createRequestTypes('UPDATE_PREFERENCE');
export const UPDATE_PREFERENCE_META = createRequestTypes('UPDATE_PREFERENCE_META');
export const SELECT_PREFERENCE = 'SELECT_PREFERENCE';
export const CHANGE_PREFERENCE = 'CHANGE_PREFERENCE';
export const CLEAR_SELECT_PREFERENCE = 'CLEAR_SELECT_PREFERENCE';

/**
 * ADMIN PANEL - preference
 * */
export const GET_MAIL_RECOGNIZE_SPAM_LIST = createRequestTypes('GET_MAIL_RECOGNIZE_SPAM_LIST');
export const CREATE_MAIL_RECOGNIZE_SPAM_LIST = createRequestTypes('CREATE_MAIL_RECOGNIZE_SPAM_LIST');
export const UPDATE_MAIL_RECOGNIZE_SPAM_LIST = createRequestTypes('UPDATE_MAIL_RECOGNIZE_SPAM_LIST');

/**
 * Cargo orders
 * */
export const GET_CARGO_ORDERS = 'GET_CARGO_ORDERS';
export const UPDATE_CARGO_ORDER = 'UPDATE_CARGO_ORDER';
export const REMOVE_LAST_CARGO_ORDER = 'REMOVE_LAST_CARGO_ORDER';
export const ADD_CARGO_ORDER = 'ADD_CARGO_ORDER';
export const CREATE_CARGO_ORDERS = 'CREATE_CARGO_ORDERS';
export const CLEAR_CARGO_ORDER_MESSAGE = 'CLEAR_CARGO_ORDER_MESSAGE';
export const UPDATE_CARGO_ORDER_USER = 'UPDATE_CARGO_ORDER_USER';
export const REMOVE_ALL_CARGO_ORDERS = 'REMOVE_ALL_CARGO_ORDERS';
export const RESET_CARGO_ORDERS = 'RESET_CARGO_ORDERS';

/**
 * Tc orders
 * */
export const GET_TC_ORDERS = 'GET_TC_ORDERS';
export const UPDATE_TC_ORDER = 'UPDATE_TC_ORDER';
export const REMOVE_LAST_TC_ORDER = 'REMOVE_LAST_TC_ORDER';
export const ADD_TC_ORDER = 'ADD_TC_ORDER';
export const CREATE_TC_ORDERS = 'CREATE_TC_ORDERS';
export const CLEAR_TC_ORDER_MESSAGE = 'CLEAR_TC_ORDER_MESSAGE';
export const UPDATE_TC_ORDER_USER = 'UPDATE_TC_ORDER_USER';
export const REMOVE_ALL_TC_ORDERS = 'REMOVE_ALL_TC_ORDERS';
export const RESET_TC_ORDERS = 'RESET_TC_ORDERS';

/**
 * Cargo request
 * */
export const POST_CARGO_REQUEST = createRequestTypes('POST_CARGO_REQUEST');
export const GET_CARGO_REQUESTS = createRequestTypes('GET_CARGO_REQUESTS');
export const UPDATE_CARGO_REQUEST = createRequestTypes('UPDATE_CARGO_REQUEST');
export const DELETE_CARGO_REQUEST = createRequestTypes('DELETE_CARGO_REQUEST');
export const CLEAR_CARGO_REQUEST_MESSAGE = 'CLEAR_CARGO_REQUEST_MESSAGE';

/**
 * TC request
 * */
export const POST_TC_REQUEST = createRequestTypes('POST_TC_REQUEST');
export const GET_TC_REQUESTS = createRequestTypes('GET_TC_REQUESTS');
export const DELETE_TC_REQUEST = createRequestTypes('DELETE_TC_REQUEST');

/** Tc index
 */
export const GET_TC_INDEXES = createRequestTypes('GET_TC_INDEXES');
/**
 * Vessel request
 * */
export const GET_VESSEL_REQUESTS = createRequestTypes('GET_VESSEL_REQUESTS');
export const POST_VESSEL_REQUEST = createRequestTypes('POST_VESSEL_REQUEST');
export const UPDATE_VESSEL_REQUEST = createRequestTypes('UPDATE_VESSEL_REQUEST');
export const DELETE_VESSEL_REQUEST = createRequestTypes('DELETE_VESSEL_REQUEST');
export const CONFIRM_VESSEL = createRequestTypes('CONFIRM_VESSEL');
export const CLEAR_VESSEL_REQUEST_MESSAGE = 'CLEAR_VESSEL_REQUEST_MESSAGE';

/**
 * Vessel orders
 * */
export const GET_VESSEL_ORDERS = 'GET_VESSEL_ORDERS';
export const UPDATE_VESSEL_ORDER = 'UPDATE_VESSEL_ORDER';
export const REMOVE_LAST_VESSEL_ORDER = 'REMOVE_LAST_VESSEL_ORDER';
export const ADD_VESSEL_ORDER = 'ADD_VESSEL_ORDER';
export const CREATE_VESSEL_ORDERS = 'CREATE_VESSEL_ORDERS';
export const CLEAR_VESSEL_ORDER_MESSAGE = 'CLEAR_VESSEL_ORDER_MESSAGE';
export const UPDATE_VESSEL_ORDER_USER = 'UPDATE_VESSEL_ORDER_USER';
export const REMOVE_ALL_VESSEL_ORDERS = 'REMOVE_ALL_VESSEL_ORDERS';
export const RESET_VESSEL_ORDERS = 'RESET_VESSEL_ORDERS';

/**
 * Vessel sizes
 */
export const GET_VESSEL_SIZES = 'GET_VESSEL_SIZES';
export const CREATE_VESSEL_SIZES = 'CREATE_VESSEL_SIZES';
export const UPDATE_VESSEL_SIZE = 'UPDATE_VESSEL_SIZE';
export const UPDATE_VESSEL_SIZE_USER = 'UPDATE_VESSEL_SIZE_USER';
export const ADD_VESSEL_SIZE = 'ADD_VESSEL_SIZE';
export const REMOVE_LAST_VESSEL_SIZE = 'REMOVE_LAST_VESSEL_SIZE';
export const REMOVE_ALL_VESSEL_SIZES = 'REMOVE_ALL_VESSEL_SIZES';

export const NOTIFICATION_PURPOSE_REQUIRED = 'NOTIFICATION_PURPOSE_REQUIRED';

/**
 * Vessel sales
 */
export const GET_VESSEL_SALES = createRequestTypes('GET_VESSEL_SALES');
export const CREATE_VESSEL_SALES = 'CREATE_VESSEL_SALES';
export const UPDATE_VESSEL_SALE = 'UPDATE_VESSEL_SALE';
export const UPDATE_VESSEL_SALE_USER = 'UPDATE_VESSEL_SALE_USER';
export const ADD_VESSEL_SALE = 'ADD_VESSEL_SALE';
export const REMOVE_LAST_VESSEL_SALE = 'REMOVE_LAST_VESSEL_SALE';
export const REMOVE_ALL_VESSEL_SALES = 'REMOVE_ALL_VESSEL_SALES';
export const POST_VESSEL_SALE = createRequestTypes('POST_VESSEL_SALE');
export const DELETE_VESSEL_SALE = createRequestTypes('DELETE_VESSEL_SALE');
export const RESET_VESSEL_SALES = 'RESET_VESSEL_SALES';
/**
 * Vessels
 * */
export const GET_VESSELS = createRequestTypes('GET_VESSELS');
export const GET_VESSEL = createRequestTypes('GET_VESSEL');
export const DELETE_NAME_SUGGESTION = createRequestTypes('DELETE_NAME_SUGGESTION');
export const RENAME_VESSEL = createRequestTypes('RENAME_VESSEL');
export const UPDATE_VESSEL = createRequestTypes('UPDATE_VESSEL');
export const DELETE_VESSEL = createRequestTypes('DELETE_VESSEL');
export const ADD_VESSEL = createRequestTypes('ADD_VESSEL');
export const SAVE_VESSEL = 'SAVE_VESSEL';
export const CLEAR_VESSEL = 'CLEAR_VESSEL';
export const UPDATE_VESSEL_IMAGE = createRequestTypes('UPDATE_VESSEL_IMAGE');

/**
 * Vessel claims
 * */
export const GET_VESSEL_CLAIMS = createRequestTypes('GET_VESSEL_CLAIMS');
export const ACCEPT_USER_CLAIMS_TO_VESSEL = createRequestTypes('ACCEPT_USER_CLAIMS_TO_VESSEL');
export const REJECT_USER_CLAIMS_TO_VESSEL = createRequestTypes('REJECT_USER_CLAIMS_TO_VESSEL');

/**
 * Gazetters
 * */
export const POST_GAZETTERS = createRequestTypes('POST_GAZETTERS');
export const SAVE_GAZETTERS = createRequestTypes('SAVE_GAZETTERS');
export const REMOVE_GAZETTERS = 'REMOVE_GAZETTERS';
export const LIST_GAZETTERS = createRequestTypes('LIST_GAZETTERS');

/**
 * Contracts
 * */
export const GET_CONTRACTS = createRequestTypes('GET_CONTRACTS');
export const GET_TIME_CONTRACTS = createRequestTypes('GET_TIME_CONTRACTS');

/**
 * Notifications
 * */
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';

export const GET_BACKEND_NOTIFICATIONS = createRequestTypes('GET_BACKEND_NOTIFICATIONS');
export const GET_BACKEND_NOTIFICATION = createRequestTypes('GET_BACKEND_NOTIFICATIONS');
export const UPDATE_BACKEND_NOTIFICATION = createRequestTypes('UPDATE_BACKEND_NOTIFICATION');
export const DELETE_BACKEND_NOTIFICATION = createRequestTypes('DELETE_BACKEND_NOTIFICATION');
export const CREATE_BACKEND_NOTIFICATION = createRequestTypes('CREATE_BACKEND_NOTIFICATION');

/**
 * Countries
 * */
export const GET_COUNTRIES = createRequestTypes('GET_COUNTRIES');

/**
 * Companies
 * */
export const GET_COMPANIES = createRequestTypes('GET_COMPANIES');
export const GET_REAL_COMPANIES = createRequestTypes('GET_REAL_COMPANIES');

/**
 * Analytics dashboard
 */
export const GET_ANALYTICS_LINKS_LIST = createRequestTypes('GET_ANALYTICS_LINKS_LIST');

/**
 * Companies
 * */
export const SEND_TRAIN = createRequestTypes('SEND_TRAIN');

/**
 * Yards
 */
export const ADD_YARD = createRequestTypes('ADD_YARD');
export const FIND_YARDS = createRequestTypes('FIND_YARDS');
export const GET_YARD = createRequestTypes('GET_YARD');

/**
 * Statistics
 * */
export const GET_STATISTICS_USERS = createRequestTypes('GET_STATISTICS_USERS');
export const SEARCH_STATISTICS_USERS = 'SEARCH_STATISTICS_USERS';

export const GET_STATISTICS_EMAILS = createRequestTypes('GET_STATISTICS_EMAILS');
export const SEARCH_STATISTICS_EMAILS = 'SEARCH_STATISTICS_EMAILS';

export const GET_STATISTICS_MONITOR = createRequestTypes('GET_STATISTICS_MONITOR');
export const SEARCH_STATISTICS_MONITOR = 'SEARCH_STATISTICS_MONITOR';

export const GET_STATISTICS_CARGO_REQUESTS = createRequestTypes('GET_STATISTICS_CARGO_REQUESTS');
export const SEARCH_STATISTICS_CARGO_REQUESTS =
    'SEARCH_STATISTICS_CARGO_REQUESTS';

export const GET_STATISTICS_VESSEL_POSITIONS = createRequestTypes('GET_STATISTICS_VESSEL_POSITIONS');
export const SEARCH_STATISTICS_VESSEL_POSITIONS =
    'SEARCH_STATISTICS_VESSEL_POSITIONS';

/**
 * Sender
 * */
export const GET_SEND_EMAIL_LIST = createRequestTypes('GET_SEND_EMAIL_LIST');
export const GET_SEND_EMAIL = createRequestTypes('GET_SEND_EMAIL');

/**
 * Domains
 * */
export const CONNECT_NEW_DOMAIN_TO_USER = createRequestTypes('CONNECT_NEW_DOMAIN_TO_USER');
export const DELETE_DOMAIN = createRequestTypes('DELETE_DOMAIN');
export const GET_LIST_DOMAIN = createRequestTypes('GET_LIST_DOMAIN');

/**
 * Subscribers
 * */
export const GET_SUBSCRIBERS = createRequestTypes('GET_SUBSCRIBERS');

/**
 * LD Rates
 */
export const GET_REQ_LD_RATES = createRequestTypes('GET_REQ_LD_RATES');
export const DELETE_REQ_LD_RATES = createRequestTypes('DELETE_REQ_LD_RATES');
export const EDIT_REQ_LD_RATES = createRequestTypes('EDIT_REQ_LD_RATES');

// Gazetters trainings
export const SEND_GAZETTER_TRAININGS = createRequestTypes('SEND_GAZETTER_TRAININGS');
export const DELETE_GAZETTER_TRAINING = createRequestTypes('DELETE_GAZETTER_TRAINING');
// integrators

export const GET_INTEGRATORS = createRequestTypes('GET_INTEGRATORS');

// integrator companies

export const GET_INTEGRATOR_COMPANIES = createRequestTypes('GET_INTEGRATOR_COMPANIES');

// company user
export const GET_COMPANY_USER = createRequestTypes('GET_COMPANY_USER');

// flag compliance
export const GET_FLAG_COMPLIANCE = createRequestTypes('GET_FLAG_COMPLIANCE');

// issue reports
export const GET_ISSUES = createRequestTypes('GET_ISSUES');
export const GET_ISSUE = createRequestTypes('GET_ISSUE');
export const UPDATE_ISSUE_STATUS = createRequestTypes('UPDATE_ISSUE_STATUS');
export const ADD_ISSUE_COMMENT = createRequestTypes('ADD_ISSUE_COMMENT');
export const UPDATE_ISSUE_COMMENT = createRequestTypes('UPDATE_ISSUE_COMMENT');
export const DELETE_ISSUE_COMMENT = createRequestTypes('DELETE_ISSUE_COMMENT');

// save requests data
export const SAVE_REQUESTS_DATA_CREATED = createRequestTypes('SAVE_REQUESTS_DATA_CREATED');
export const SAVE_REQUESTS_DATA_DELETED = createRequestTypes('SAVE_REQUESTS_DATA_DELETED');

/**
 * Hires
 * */
export const UPDATE_HIRE_ORDER = 'UPDATE_HIRE_ORDER';
export const REMOVE_LAST_HIRE_ORDER = 'REMOVE_LAST_HIRE_ORDER';
export const ADD_HIRE_ORDER = 'ADD_HIRE_ORDER';
export const CREATE_HIRE_ORDERS = 'CREATE_HIRE_ORDERS';
export const UPDATE_HIRE_ORDER_USER = 'UPDATE_HIRE_ORDER_USER';
export const REMOVE_ALL_HIRE_ORDERS = 'REMOVE_ALL_HIRE_ORDERS';

/**
 * Hire request
 * */
export const GET_HIRE_ORDERS = createRequestTypes('GET_HIRE_ORDERS');
export const POST_HIRE_REQUEST = createRequestTypes('POST_HIRE_REQUEST');
export const UPDATE_HIRE_REQUEST = createRequestTypes('UPDATE_HIRE_REQUEST');
export const DELETE_HIRE_REQUEST = createRequestTypes('DELETE_HIRE_REQUEST');



// WEBPACK FOOTER //
// ./app/constants/ActionTypes.js